import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from 'src/app/api/api-configuration';
import { ApiResponse } from 'src/app/api/api-response.model';
import { RepresentativeUser } from '@models/user';

@Injectable({
  providedIn: 'root',
})
export class RepresentativeService {
  constructor(private http: HttpClient, private config: ApiConfiguration) {}

  insert(payload: {
    idUser: string;
    idCompany: string;
  }): Observable<ApiResponse<any>> {
    const url = `${this.config.rootUrl}/representante`;
    return this.http.post<ApiResponse<any>>(url, payload);
  }

  searchByParam(
    param: string | null | undefined
  ): Observable<ApiResponse<{ users: RepresentativeUser[] }>> {
    const safeParam = (param ?? '').toString().trim() || '';
    const url = `${
      this.config.rootUrl
    }/usuario/busqueda-por-correo?param=${encodeURIComponent(safeParam)}`;
    return this.http.get<ApiResponse<{ users: RepresentativeUser[] }>>(url);
  }

  getByIdCompany(
    idCompany: string
  ): Observable<ApiResponse<{ users: RepresentativeUser[] }>> {
    const url = `${this.config.rootUrl}/representante/obtener-por-compania?idCompany=${idCompany}`;
    return this.http.get<ApiResponse<{ users: RepresentativeUser[] }>>(url);
  }

  remove(payload: {
    idUser: string;
    idCompany: string;
  }): Observable<ApiResponse<any>> {
    const url = `${this.config.rootUrl}/representante/remover`;
    return this.http.post<ApiResponse<any>>(url, payload);
  }
}
